<template>
  <v-row align="center" justify="center" class="backgroundColor" max-width="100%">
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="close()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>

          <v-row align="center" justify="center">
            <img src="../assets/ok.svg" width="30%" class="ma-3" />
          </v-row>
          
          <v-row align="center" justify="center" class="ma-2">
            <v-col>
              <v-row align="center" justify="center">
              <h1><b>¡Servicio agendado!</b></h1>
              </v-row>
            </v-col>
          </v-row>
          
          <v-row align="center" justify="center">
            <v-col cols="10">
              <v-row align="center" justify="center">
                <p class="textCenter">
                  Hemos recibido tu información y ha sido agendado tu servicio con éxito.
                </p>
              </v-row>
            </v-col>
          </v-row>
          
          <v-row align="center" justify="center">
            <v-col cols="8">
              <v-row align="center" justify="center">
                <v-btn class="buttonPrimary" block rounded @click="close()">
                    Entendido
                </v-btn>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
  </v-row>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
  computed: {
    ...mapFields(["servicioSolicitado", "loader"]),
  },
  mounted() {
    if (
      !this.servicioSolicitado
    ) {
      this.$router.push({ name: "Home" });
    }
  },
  methods: {
    close() {
      this.$router.push({ name: "Home" });
    },
  },
};


window.dataLayer = window.dataLayer || [];
window.dataLayer.push({
    'event': 'Pageview',
    'pagePath': 'https://okboy.app/pedidoexitoso',
    'pageTitle': 'Service registration Completed'
  });

  window.dataLayer = window.dataLayer || [];

  dataLayer.push({
    'event': 'ServicioExitoso'
  })
</script>

<style scoped>
.backgroundColor {
  background-color: #f1f3f6;
  margin-top: 50px;
}
</style>